import { useEffect, useState } from 'react';

import UploadIcon from '@mui/icons-material/Upload';
import { useRecordModal } from 'hooks/useRecordModal';
import { MethodsImageField } from 'pages/Methods/components/MethodsImageField/MethodsImageField';
import { MethodsLogoAutocompleteInput } from 'pages/Methods/components/MethodsLogoAutocompleteInput';
import { MethodsLogoCreateLogoModal } from 'pages/Methods/components/MethodsLogoCreateLogoModal';
import { useMethodDefaultLogo } from 'pages/Methods/hooks/useMethodDefaultLogo';
import { required, useRecordContext } from 'react-admin';
import { Button } from 'shared/mui/Buttons';
import { Stack } from 'shared/mui/Stack/Stack';
import {
  AutocompleteInput,
  BooleanInput,
  TextInputIntrospected,
  GenerateNameInput,
} from 'shared/react-admin/Inputs';
import {
  ReferenceArrayInputIntrospected,
  ReferenceInput,
} from 'shared/react-admin/ReferenceInputs';
import { Method } from 'types/embedded/method';

import { BoxStyled } from './MethodsCreateForm.styled';

export const MethodsCreateForm: React.FC = () => {
  const record = useRecordContext<Method>();
  const [newLogoId, setNewLogoId] = useState<string | null | undefined>(null);
  const [logoImageUrl, setLogoImageUrl] = useState<string | null | undefined>(null);
  const { handleCloseRecordModal, openRecordModal, handleOpenRecordModal } = useRecordModal<null>();

  const defaultLogo = useMethodDefaultLogo(newLogoId, record?.logo?.['@id']);

  useEffect(() => {
    if (defaultLogo) {
      setLogoImageUrl(defaultLogo.filePath);
    }
  }, [defaultLogo, defaultLogo?.filePath]);

  return (
    <>
      <BooleanInput
        defaultValue={true}
        label="Активен"
        size="small"
        source="active"
        sx={{ marginBottom: '24px', '& .MuiFormControlLabel-root': { marginLeft: 0 } }}
      />
      <Stack direction="row" gap="24px" justifyContent="space-between" mb="4px">
        <GenerateNameInput
          fullWidth
          isRequired
          label="Название"
          size="small"
          slotProps={{ inputLabel: { shrink: true } }}
          source="name"
          variant="outlined"
        />
        <TextInputIntrospected
          fullWidth
          label="Алиас"
          size="small"
          slotProps={{ inputLabel: { shrink: true } }}
          source="alias"
          variant="outlined"
        />
      </Stack>
      <ReferenceInput reference="method_types" source="methodType">
        <AutocompleteInput
          filterToQuery={(searchText: string) => ({ name: searchText })}
          fullWidth
          isRequired
          label="Тип метода"
          optionText="name"
          size="small"
          source="methodType"
          sx={{ marginBottom: 0 }}
          validate={required()}
          variant="outlined"
        />
      </ReferenceInput>
      <Stack direction="row" gap="24px" justifyContent="space-between">
        <BoxStyled>
          <ReferenceArrayInputIntrospected
            isFilter={true}
            perPage={50}
            reference="method_logos"
            source="logo.@id"
          >
            <MethodsLogoAutocompleteInput
              defaultValue={defaultLogo}
              fullWidth
              label="Лого"
              name="logo"
              onChangeLogo={setLogoImageUrl}
              optionValue="@id"
              validate={required()}
            />
          </ReferenceArrayInputIntrospected>
          <Button
            fullWidth
            label="Загрузить новый логотип"
            onClick={() => handleOpenRecordModal(null)}
            size="large"
            startIcon={<UploadIcon />}
            sx={{ padding: '6px 21px' }}
            variant="outlined"
          />
        </BoxStyled>
        <BoxStyled>
          <MethodsImageField imgSrc={logoImageUrl} />
        </BoxStyled>
      </Stack>
      <MethodsLogoCreateLogoModal
        onClose={handleCloseRecordModal}
        onSetLogo={setNewLogoId}
        open={openRecordModal}
      />
    </>
  );
};
